import angular from "angular";
import { DateTime } from "luxon";
import { CsvWriter, vsName as csvWriterServiceName } from "./csvWriter";
import * as formatters from "./formatters";

export const vsName = csvWriterServiceName
export const vsProviderName = `${csvWriterServiceName}Provider`

export class CsvWriterProvider
  implements angular.IServiceProvider {

  static formatters: { [formatterName: string]: formatters.IValueFormatter } = {
    "currency": formatters.currencyFormatter,
    "date": formatters.dateFormatterFactory(),
    "date-time": formatters.dateFormatterFactory({ options: DateTime.DATETIME_SHORT }),
    "double": formatters.numberFormatterFactory(),
    "int32": formatters.numberFormatterFactory({ decimalPlaces: 0 }),
    "int64": formatters.numberFormatterFactory({ decimalPlaces: 0 }),
    "percentage": formatters.percentageFormatter,
    "boolean": formatters.booleanFormatterFactory()
  }

  readonly $get = ['$window', ($window: angular.IWindowService) => {
    return new CsvWriter($window, {
      formatters: CsvWriterProvider.formatters
    })
  }]
}